/* eslint-disable ordered-imports/ordered-imports */
/* eslint-disable spire/fenced-imports */
/* eslint-disable camelcase */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { RegularFacet, NumericFacet, CategoryFacet, DateFacet, LocationFacet } from "@coveo/headless/commerce";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import addProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import removeProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductListPageContext } from "@insite/content-library/Pages/ProductListPage";
import { getProp } from "@insite/mobius/utilities";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import CoveoCategoryFacet from "@NA/Widgets/Coveo/Facet/CoveoCategoryFacet";
import { ProductListFilterAccordionSectionStyles } from "@NA/Widgets/Coveo/Facet/CoveoFacetAccordionContainer";
import CoveoRegularFacet from "@NA/Widgets/Coveo/Facet/CoveoRegularFacet";
import { withCoveoHooks, HasCoveoHooks } from "@NA/Components/Coveo/Contexts/CoveoHooksContext";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    expandByDefault = "expandByDefault",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.expandByDefault]: boolean;
    };
}

const mapStateToProps = (state: CustomApplicationState) => {
    const currentPathname = getLocation(state).pathname;
    return {
        session: state.context.session,
        attributeTypeFacets: getProductListDataViewProperty(state, "attributeTypeFacets"),
        location: getLocation(state),
        showMobileFilter: state.ADIGlobalData.ADIMobileFilterStore.showMobileFilters,
        myBranchDetails: state.ADIGlobalData.myBranchStore,
        isDealsPage: currentPathname.toLowerCase().includes("catalog/deals"),
    };
};

const mapDispatchToProps = {
    addProductFilters,
    removeProductFilters,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps & HasCoveoHooks;

export const productListAttributeFiltersStyles: ProductListFilterAccordionSectionStyles = {
    filterText: {
        variant: "h3",
        css: css`
            margin-bottom: 0;
            font-size: ${getProp("theme.typography.h6.size")};
            font-weight: 800;
        `,
    },
};

export type GeneratedFacetController = RegularFacet | DateFacet | NumericFacet | CategoryFacet | LocationFacet;
export type GeneratedFacetControllers = GeneratedFacetController[];

const desiredOrder = [
    "ec_availability",
    "ec_brand",
    "ec_category_name",
    "ec_product_type",
    "ec_sub_category",
    "ec_product_group",
    "ec_more_ways_to_save",
    "ec_product_line",
];

const CoveoProductListAttributeFilters: FC<Props> = ({
    showMobileFilter,
    myBranchDetails,
    session,
    facetGenerator,
}) => {
    const sortedFacets = () => {
        if (!facetGenerator?.state) {
            return [];
        }

        let facets: GeneratedFacetController[];

        if (IS_SERVER_SIDE) {
            const serverfacets = facetGenerator.state.map((state: any) => {
                const facetController = {
                    state: state,
                    type: state.type,
                    subscribe: (callback: () => void) => {
                        callback();
                        return () => {};
                    },
                    toggleSelect: () => {},
                    toggleExclude: () => {},
                    toggleSingle: () => {},
                    showMoreValues: () => {},
                    showLessValues: () => {},
                    isValueSelected: () => false,
                    isValueExcluded: () => false,
                };
                return facetController as GeneratedFacetController;
            });
            facets = serverfacets;
        } else {
            const clientFacets = facetGenerator.state
                .map((state: any) => {
                    const facet = facetGenerator.methods?.getFacetController?.(state.facetId, state.type);
                    return facet;
                })
                .filter((facet: any): facet is GeneratedFacetController => facet !== undefined);
            facets = clientFacets;
        }

        const sorted = facets.sort((a: GeneratedFacetController, b: GeneratedFacetController) => {
            const indexA = desiredOrder.indexOf(a.state.facetId);
            const indexB = desiredOrder.indexOf(b.state.facetId);

            if (indexA === -1 && indexB === -1) {
                return 0;
            }
            if (indexA === -1) {
                return 1;
            }
            if (indexB === -1) {
                return -1;
            }
            return indexA - indexB;
        });

        return sorted;
    };

    return (
        <>
            {sortedFacets().map((facet: GeneratedFacetController) => {
                switch (facet.type) {
                    case "regular":
                        return (
                            <CoveoRegularFacet
                                key={facet.state.facetId}
                                facet={facet}
                                showMobileFilter={showMobileFilter}
                                isAuthenticated={session.isAuthenticated}
                                myBranchDetails={myBranchDetails}
                            />
                        );
                    case "hierarchical":
                        return (
                            <CoveoCategoryFacet
                                key={facet.state.facetId}
                                facet={facet}
                                showMobileFilter={showMobileFilter}
                                isAuthenticated={session.isAuthenticated}
                                myBranchDetails={myBranchDetails}
                            />
                        );
                    default:
                        return null;
                }
            })}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withCoveoHooks(CoveoProductListAttributeFilters)),
    definition: {
        group: "Product List",
        displayName: "Coveo Attribute Filters",
        allowedContexts: [ProductListPageContext],
        fieldDefinitions: [
            {
                name: "expandByDefault",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
